'use client';

import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';

export function PasswordStrengthIndicator({ password }: { password: string }) {
  const t = useTranslations('auth.passwordStrength');

  const RULES = [
    { label: t('minLength'), test: (v: string) => v.length >= 8 },
    { label: t('uppercase'), test: (v: string) => /[A-Z]/.test(v) },
    { label: t('lowercase'), test: (v: string) => /[a-z]/.test(v) },
    { label: t('digit'), test: (v: string) => /[0-9]/.test(v) },
    { label: t('special'), test: (v: string) => /[^A-Za-z0-9]/.test(v) }
  ];

  return (
    <ul className='space-y-1 text-sm'>
      {RULES.map((rule) => {
        const pass = rule.test(password);
        return (
          <li
            key={rule.label}
            className={cn(
              'flex items-center gap-2',
              pass ? 'text-green-600' : 'text-muted-foreground'
            )}
          >
            <span
              className={cn(
                'inline-block h-2 w-2 rounded-full',
                pass ? 'bg-green-600' : 'bg-muted-foreground/40'
              )}
            />
            {rule.label}
          </li>
        );
      })}
    </ul>
  );
}
